// src/store/useAdminStore.ts
import { create } from "zustand";

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch (e) {
    console.error("❌ Failed to parse auth token:", e);
    return null;
  }
};

const updateAuthStorageProfileFlag = () => {
  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return;

    const parsed = JSON.parse(raw);
    parsed.state.dataProfile = true;

    localStorage.setItem("auth-storage", JSON.stringify(parsed));
  } catch (e) {
    console.error("❌ Failed to update auth-storage:", e);
  }
};

type UpdateUserProfilePayload = {
  name: string;
  position: string;
  phone: string;
  email: string;
  photo?: File | null;
};

type AdminStore = {
  updateUserProfile: (
    payload: UpdateUserProfilePayload
  ) => Promise<{ success: boolean; message?: string }>;
};

export const useAdminStore = create<AdminStore>(() => ({
  updateUserProfile: async (payload) => {
    const token = getAccessToken();
    if (!token) {
      return { success: false, message: "Unauthorized" };
    }

    try {
      const form = new FormData();
      form.append("name", payload.name);
      form.append("position", payload.position);
      form.append("phone", payload.phone);
      form.append("email", payload.email);

      if (payload.photo) {
        form.append("photo", payload.photo);
      }

      const res = await fetch(
        "https://admin.talentlinkindo.com/api/company/user-profile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json", 
          },
          body: form,
        }
      );

      const result = await res.json();

      if (!res.ok) {
        throw new Error(result?.message || "Failed to update user profile");
      }

      updateAuthStorageProfileFlag();

      return {
        success: true,
        message: result.message,
      };
    } catch (e: any) {
      console.error("❌ Update user profile failed:", e);
      return {
        success: false,
        message: e.message || "Unknown error",
      };
    }
  },
}));
